
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/worksheets",
      function () {
        return require("private-next-pages/worksheets/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/worksheets"])
      });
    }
  